import { axiosCashJournalClient } from "../api";
import { MIDDLE_URL } from "../config";
import { IPostTrxApprovalData } from "../trxApprovalService";

export interface Lstsmplmstjobtitle {
  id: number,
  job_title: string,
  description: string,
  code_type: string,
  create_at: string,
  create_by: string,
  update_at: string,
  update_by: string
}

export interface IJobTitleList {
  lstsmplmstjobtitle: Lstsmplmstjobtitle[]
}

const url = "/v1/jobtitle";

export const jobTItleAPI = {
  getList: async (): Promise<IJobTitleList> => {
    const { data } = await axiosCashJournalClient({
      method: "GET",
      url: `${MIDDLE_URL}${url}`,
    });
    return data;
  },
  putJobTitle: async (payload: {
    id: number,
    job_title: string,
    description: string,
    code_type: string,
    create_by: string
  }): Promise<IPostTrxApprovalData> => {
    const { data } = await axiosCashJournalClient({
      method: "PUT",
      url: `${MIDDLE_URL}${url}`,
      data: payload,
    });
    return data;
  },
  deleteJobTitle: async (id: number): Promise<IPostTrxApprovalData> => {
    const { data } = await axiosCashJournalClient({
      method: "DELETE",
      url: `${MIDDLE_URL}${url}/${id}`,
    });
    return data;
  },
  addJobTitle: async (payload: {
    job_title: string,
    description: string,
    code_type: string,
    create_by: string
  }): Promise<IPostTrxApprovalData> => {
    const { data } = await axiosCashJournalClient({
      method: "POST",
      url: `${MIDDLE_URL}${url}`,
      data: payload,
    });
    return data;
  },
};
